import { Model as e } from "../../../../model.js";
class n extends e {
  constructor(s) {
    super(), this.brands = s.brands, this.name = s.name, this.type = s.type;
  }
}
export {
  n as AdyenPaymentMethodModel
};
//# sourceMappingURL=adyenPaymentMethod.model.js.map
